import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [["region", "1 region"], ["extra_region", "Each extra region"], ["everywhere", "Everywhere (national)"]];

export default function BannerPricingForm() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/banners/pricing").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const set = (period, k, v) => setP({ ...p, [period]: { ...p[period], [k]: v } });
  const save = async () => {
    const num = (o) => Object.fromEntries(Object.entries(o).map(([k, v]) => [k, Number(v)]));
    try { const { data } = await api.put("/admin/banner-pricing", { week: num(p.week), month: num(p.month), max_rotation: Number(p.max_rotation) }); setP(data); toast.success("Banner prices saved"); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <Card data-testid="banner-pricing-card">
      <CardHeader>
        <CardTitle className="font-display text-xl">Banner prices (NZD)</CardTitle>
        <CardDescription>{p.placeholder ? "These are placeholder prices — set your own and save." : "Regional banners: split evenly across chosen regions, 65% to each operator after fees. Everywhere (national) banners are the only ones on markdowns.nz and rotate on every region: 100% to you."}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {["week", "month"].map((period) => (
          <div key={period}>
            <div className="text-xs font-black uppercase tracking-widest text-emerald-700 mb-1">Per {period}</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
              {FIELDS.map(([k, label]) => (
                <div key={k}><Label className="text-xs">{label}</Label><Input type="number" min="0" step="1" value={p[period][k]} onChange={(e) => set(period, k, e.target.value)} data-testid={`price-${period}-${k}`} /></div>
              ))}
            </div>
          </div>
        ))}
        <div className="w-48"><Label className="text-xs">Max banners rotating per spot</Label><Input type="number" min="1" max="20" value={p.max_rotation} onChange={(e) => setP({ ...p, max_rotation: e.target.value })} data-testid="price-max-rotation" /></div>
        <Button onClick={save} className="bg-emerald-800 hover:bg-emerald-900" data-testid="banner-pricing-save">Save prices</Button>
      </CardContent>
    </Card>
  );
}
